import { render, staticRenderFns } from "./scene_2.vue?vue&type=template&id=65cc4022&"
import script from "./scene_2.vue?vue&type=script&lang=ts&"
export * from "./scene_2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports